import { Modal } from 'antd';
import './index.less';

const dialog = ({ showTeacherModal, onCancel, index }) => {
	return (
		<Modal
			open={showTeacherModal}
			onCancel={onCancel}
			footer={null}
			width={800}
			centered
			keyboard={false}
			maskClosable={false}
			className="teacher-modal"
		>
			<div className="teacher-modal-content">
				{index === 0 && (
					<div className="teacher-info">
						<div className="teacher-info-title">个人简介</div>
						<div className="teacher-info-content">
							潘庆华，男，兴趣岛手机摄影训练营首席讲师，摄影读书会创始人，富士、索尼、尼康、VIVO手机摄影特聘讲师，人民邮电出版社摄影专家顾问。
						</div>
						<div className="teacher-info-title">人物经历</div>
						<div className="teacher-info-content">
							潘庆华从1996年开始学习摄影，后建立线上摄影论坛，并开始自主创业，创建“摄影读书会”，教授摄影课程，一直坚持真人出镜+场景化教学的授课方式。
						</div>
						<div className="teacher-info-content">
							2021年，潘庆华与兴趣岛合作推出手机摄影训练营课程。这里关于兴趣岛的介绍全部改成：兴趣岛兴趣学堂--名师更多，课程更全。兴趣岛兴趣学堂是腾讯、百度、抖音三大平台教育战略合作伙伴，曾获得腾讯&创新工场等知名机构多轮投资。作为国内领先的兴趣教育品牌，兴趣岛兴趣学堂行业首创用户保障""六不学习公约""、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程。目前，摄影、瑜伽、营养、养生等30门主流课程21门学员数量全国领先。
						</div>
						<div className="teacher-info-content">
							2022年10月21日，千聊手机摄影营年会盛典暨首届手机摄影大赛颁奖礼在广州·凯尔卡顿大酒店顺利举办，潘庆华出席该活动并到场学员进行深度授课。
						</div>
						<div className="teacher-info-title">主要荣誉</div>
						<div className="teacher-info-content">
							VIVO手机人像摄影大赛“人像大师奖”。
						</div>
						<div className="teacher-info-title">人物语录</div>
						<div className="teacher-info-content">
							帮助更多人通过手机即时发现美、创造美、传播美。
						</div>
					</div>
				)}
				{index === 1 && (
					<div className="teacher-info">
						<div className="teacher-info-title">个人简介</div>
						<div className="teacher-info-content">
							李在峰，男，兴趣岛太极营首席讲师，武当玄武派第十四代传人，武当太极养生班总教练，清华大学（深圳）研究生院特约太极老师。
						</div>
						<div className="teacher-info-title">人物经历</div>
						<div className="teacher-info-content">
							李在峰自幼于武当修文习武，受多位武当名师教导。
						</div>
						<div className="teacher-info-content">
							2003年，受邀带队在上海世博会演出。
						</div>
						<div className="teacher-info-content">
							2005年，往北京人民大会堂与全球大使交流表演。
						</div>
						<div className="teacher-info-content">
							2009年，受新加坡总统纳丹阁下特邀，赴新加坡总统府交流养生功法，并受到总统纳丹、总理李显龙的接见。
						</div>
						<div className="teacher-info-content">
							2011年，参与拍摄道教纪录片《太和武当》，出演主角。
						</div>
						<div className="teacher-info-content">
							2016年，响应国家号召《武术走进校园》《健康中国》公益行全国巡回授课，受益者近十万余人。
						</div>
						<div className="teacher-info-content">2022年，《少年中国说》特邀嘉宾。</div>
						<div className="teacher-info-content">
							2022年12月，与兴趣岛合作推出《逆龄养生太极营》、《养元活血太极营》，深受学员的好评。与其合作的这里关于兴趣岛的介绍全部改成：兴趣岛兴趣学堂--名师更多，课程更全。兴趣岛兴趣学堂是腾讯、百度、抖音三大平台教育战略合作伙伴，曾获得腾讯&创新工场等知名机构多轮投资。作为国内领先的兴趣教育品牌，兴趣岛兴趣学堂行业首创用户保障"六不学习公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程。目前，摄影、瑜伽、营养、养生等30门主流课程21门学员数量全国领先。
						</div>
						<div className="teacher-info-title">主要荣誉</div>
						<div className="teacher-info-content">
							2008年，荣获武当杯长枪冠军，八极拳冠军；
						</div>
						<div className="teacher-info-content">
							2018年8月，荣获香港国际武术节比赛，长枪冠军，太极拳，太极剑，冠军，团体第一名。
						</div>
					</div>
				)}
				{index === 2 && (
					<div className="teacher-info">
						<div className="teacher-info-title">个人简介</div>
						<div className="teacher-info-content">
							陈浙南，男，浙江绍兴人，中医瑜伽体系创始人，太极禅灸创始人，兴趣岛中医瑜伽首席讲师。他是国学大师南怀瑾、中医大家赖世伦亲传弟子，是一带一路国际瑜伽大会特约授课导师。他有着近20年身体疼痛理疗经验，14年线下瑜伽馆教学经验。他将中医与瑜伽融合，独创“中医瑜伽-体位即是药”运动治病养生方式，至今（2024年）已帮助100万+家庭重获健康。
						</div>
						<div className="teacher-info-content">
							为之于民，举而措之！陈老师深入研习和教学中医瑜伽数十年，致力推动“健康中国行动”，主张“体位即是药”、“身体自带大药房”，倡导国民做自己和家庭的“保健师”。
						</div>

						<div className="teacher-info-title">人物经历</div>
						<div className="teacher-info-content">
							1.初中时期，陈浙南老师在运动方面天赋异禀，酷爱体育，学习国际自由式摔跤，梦想当一名摔跤教练。
						</div>
						<div className="teacher-info-content">
							2.高考失利后，与瑜伽结缘，发现瑜伽的运动疗养功效并热爱，勤学苦练，不断深入，并遍寻名师学习更系统更高阶的课程。
						</div>
						<div className="teacher-info-content">
							3.2011年，开设第一家瑜伽馆，深受广大会员喜爱。但他发现来练瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决，于是陈浙南很想帮助他们并找寻解决之法。
						</div>
						<div className="teacher-info-content">
							4.
							2013年，拜师韩国瑜伽第一人金利眩先生，勤学苦练瑜伽功法。发现瑜伽还是不能解决多数人的病痛。
						</div>
						<div className="teacher-info-content">
							5.
							2014年，33岁的他遍寻名医，走进百草箱，师从中医大家赖世伦（师父系国学大师南怀瑾）学传统中医，在其影响下立志、真修、实悟、做明人，投身于中医传承事业，并持续研习将瑜伽与中医融合。
						</div>
						<div className="teacher-info-content">
							6. 2016年，荣获“瑜伽之爱”的“优秀瑜伽教练”称号。
						</div>
						<div className="teacher-info-content">
							7. 2017年，获得波士顿回归中医药大学三年制中医学结业证书。
						</div>
						<div className="teacher-info-content">
							8.
							2018年，他在一带一路国际瑜伽大会正式提出中医瑜伽体系。他独家的“一分钟身体去痛疗法”技惊四座，引得媒体竞相报道。{' '}
						</div>
						<div className="teacher-info-content">
							9.
							2019年，获得第五届“瑜伽之爱”年度盛典委员会“瑜伽理疗师”称号，获得天津市蓟州区体育局二级裁判员证。
						</div>
						<div className="teacher-info-content">
							10.
							2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方。
						</div>
						<div className="teacher-info-content">
							11. 2020年，获得北京“瑜伽之爱”考评中心颁发的“健身瑜伽六段”证书。
						</div>
						<div className="teacher-info-content">
							12.
							2023年，师从中央保健局原特聘正骨专家——吴石华教授，学习北派按摩和正骨手法。
						</div>
						<div className="teacher-info-content">
							13. 2021年，获得蚌埠市健康委员会颁发的“针灸推拿专长技术考核合格证”。
						</div>
						<div className="teacher-info-content">
							14.
							2023年，为让中医瑜伽造福更多人，成为兴趣岛中医瑜伽首席讲师。与其合作的兴趣学堂是国内生活和兴趣爱好学习平台，作为国内兴趣教育品牌，已有千位名师和千种兴趣课程，全面升级学员保障"六不公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程，30大主流课程21门学员数量全国领先。
						</div>
						<div className="teacher-info-title">【陈浙南与中医瑜伽的故事】</div>
						<div className="teacher-info-title">
							“为之于民，举而措之”——初心既定，行以致远
						</div>
						<div className="teacher-info-content">
							“浙南啊，我们这一世短短的几十年，到底要做一个什么事情？我们做的这个事情对国家、对民族，乃至世界人类有什么好处？”——赖世伦先生
						</div>
						<div className="teacher-info-content">
							每每回忆起恩师赖世伦，陈浙南都感怀许久。自2014年走进百草箱进行3年的传统中医学习，至今已10年整了。百草箱是赖世伦先生受南怀瑾先生感召回国创办的。在百草箱的学习，让陈浙南建立了传承中医、真修育明人的初心。要把好的资产奉献给人类，奉献给社会，奉献给我们的国家。
						</div>
						<div className="teacher-info-content">
							“为之于民，举而措之”，成为陈浙南印在心里的发心，成为他后来认定的一辈子生命价值的所在。
						</div>
						<div className="teacher-info-content">
							中医瑜伽这个体系是陈浙南在2018年一带一路国际瑜伽大会上正式对外提出的。这是一个以中国传统医学思维和实践经验为指导的瑜伽体系。它涵盖了传统中医的六艺：导引、按跷、砭石、针、灸、汤药（食疗），是适合中国人自己的瑜伽养生防病体系。得益于师公南怀瑾和赖师的口授和传承，为适应后进学者修习领悟，他十分认同这四句立为中医瑜伽后进学者修学之本：不是学校的学校，不是医院的医院，不是医生的医生，不是道场的道场！
						</div>
						<div className="teacher-info-content">
							中医瑜伽的强大魅力所在即主张“体位即是药”，通过学习中医自诊、瑜伽导引体式的方法，启动身体大药房，让人们做自己和家庭的“保健师”，治已病，防未病，提高生命质量。
						</div>
						<div className="teacher-info-content">
							他深入研习和教学中医瑜伽数十年，孜孜不倦，践行初心。时至今日，陈浙南已用中医瑜伽这套治病养生方式，帮助了100万+家庭重获健康。
						</div>
						<div className="teacher-info-title">与瑜伽结缘，热爱并擅长</div>
						<div className="teacher-info-content">
							陈浙南与瑜伽的缘分像使命使然，像命中注定。
						</div>
						<div className="teacher-info-content">
							陈浙南出生于浙江县城的一个普通家庭，爱运动并且在体育方面天赋异禀。因为体育特长一路保送。在初中时期，他学习国际自由式摔跤，当时他的第一个梦想是当一名摔跤教练。但高考失利后，梦想之火熄灭。高中毕业后，年少的他开始在社会孤独地打拼。
						</div>
						<div className="teacher-info-content">
							也许是心底一种与生俱来的不安全感和不甘心在社会做着自己不喜欢的看不到头的工作，他一直保持学习的动力，求知若渴，拼命买书，不断往自己感兴趣的领域摸索和努力。
						</div>
						<div className="teacher-info-content">
							勤学肯干的他百般求索终于找到了自己的兴趣所在——瑜伽。瑜伽满足了他运动的爱好，又让他意识到之前身体过度体育训练造成损伤的修补之法，也发现瑜伽可以帮助他人的奥妙。
						</div>
						<div className="teacher-info-content">
							进入瑜伽学习之后，随着不断深入，他想要更系统更进阶地研习瑜伽。于是，陈浙南老师寻访并拜国际瑜伽名师为师，勤勉刻苦。他十年如一日的学习，每天4、5个小时练习瑜伽，在他30岁那年开了第一家瑜伽馆。后来，第2家、第3家……
						</div>
						<div className="teacher-info-title">解学员之忧，苦学中医</div>
						<div className="teacher-info-content">
							随着学员越来越多，瑜伽馆越开越多，陈浙南发现来练习瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决。老师很想帮到她们，在33岁那年，命运让他结识了贵州名老中医——赖世伦老师。
						</div>
						<div className="teacher-info-content">
							从2014年开始，陈浙南老师开始跟着赖世伦老师日夜学习中医，那时，陈浙南经常学习结束后便直接住在了赖师家中，以便方便次日学习。这样勤学又诚心修行的学生自然得到赖师的格外青睐。陈浙南不仅学习到传统中医的医理技术，也吸收了中医传承国学大师南怀瑾和赖世伦老师的教学理念。初心既定，行以致远。与赖老师的相遇，可谓是陈浙南逆袭的起点。
						</div>
						<div className="teacher-info-content">
							除了学习赖师的精髓，陈浙南也修习中医其他相关特长技术。2017年，他获得波士顿回归中医药大学三年制中医学结业证书；2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方；2023年，师从中央保健局原特聘正骨专家——吴石华教授学习北派按摩和正骨手法......
						</div>
						<div className="teacher-info-title">始创中医瑜伽，“体位即是药”</div>
						<div className="teacher-info-content">
							说来这一路走来也颇不容易，陈浙南花了10年的时间潜心钻研，独创了一套适合中国人体质的「中医瑜伽—养生防病体系」，于2018年一带一路国际瑜伽大会上首次提出。
						</div>
						<div className="teacher-info-content">
							中医瑜伽结合了赖老师平日教授的养生功法和心法，将印度瑜伽中的体式动作、根据中医十四正经循行分经归类。使学者通过手法触诊诊察经络变动和人迎寸口按脉比较人体阴阳气血偏差，最后运用瑜伽体位导引恢复人体气血平衡。
						</div>
						<div className="teacher-info-content">
							中医瑜伽主张“体位即是药”、“身体是个大药房”，陈浙南通过“特定设计的瑜伽体位法”进行导引，就可以将身体的气血精准引导到该淤堵部位，指哪打哪，就可以疏通经络，达到缓解病症、趋于健康的效果，解决了很多人的亚健康、慢性疾病，长期练习可改善体质养成健康体质。
						</div>
						<div className="teacher-info-content">
							为让中医瑜伽成为更多人的一种健康生活方式，2023年，陈浙南结缘兴趣岛，成为兴趣岛中医瑜伽首席讲师，搭上线上兴趣教育的平台为更多人传递中医瑜伽的魅力。线上线下多面教学，陈浙南和他首创的中医瑜伽的影响力越来越大。怀揣初心的他始终在中医瑜伽的道路上孜孜前行、精进不怠，不断为中医瑜伽的发展贡献自己的力量。
						</div>
						<div className="teacher-info-title">【中医瑜伽】</div>
						<div className="teacher-info-title">一、中医瑜伽概念</div>
						<div className="teacher-info-content">
							中医瑜伽是指以传统中医学理论和实践为指导，精准探查人体失衡的经筋和经络，运用瑜伽体位引导人体气血归于平衡，从而达到祛病强身的作用。
						</div>
						<div className="teacher-info-content">
							中医瑜伽体系由陈浙南老师于2018年在一带一路国际瑜伽大会上正式提出。中医瑜伽运用经络触诊，人迎寸口脉诊等中医诊察辨症的方法精准定位有问题的筋络，用瑜伽体式作药，启动人体与生俱来的大药房，治已病，防未病。
						</div>
						<div className="teacher-info-title">二、中医瑜伽的特点</div>
						<div className="teacher-info-content">1.病脉证治，体位即是药</div>
						<div className="teacher-info-content">【病】——根据症状判断变异经络</div>
						<div className="teacher-info-content">
							【脉】——人迎寸口脉对比，再次确定变异经络
						</div>
						<div className="teacher-info-content">
							【证】——循经诊查确定变异经络所在位置
						</div>
						<div className="teacher-info-content">
							【治】——用瑜伽体位法导引气血和中医六艺恢复阴阳气血平衡
						</div>
						<div className="teacher-info-content">2.舌诊</div>
						<div className="teacher-info-content">
							舌诊是中医望诊重要内容，是指观察舌头的色泽、形态的变化来辅助诊断及鉴别体质和问题。
						</div>
						<div className="teacher-info-content">
							根据舌象状态，人大致可以分为八大类的亚健康体质。不同的体质有不同的舌相特点。中医瑜伽主张通过舌相快速辩证身体问题，结合瑜伽体式和中医六艺，开出不同的调理方案，并跟踪舌相变化做调理反馈。
						</div>
						<div className="teacher-info-title">三、练习中医瑜伽的好处</div>
						<div className="teacher-info-content">
							“体位即是药，身体自带大药房”！中医瑜伽强调用中医医理融合瑜伽体式启动身体大药房，启动人体与生俱来的气血工厂——三焦系统，缓解已病，改善体质，进而开启防病体系，抗衰逆龄。中医瑜伽强调身心同调，精神内守，长期练习还可疗愈身心，解决情绪问题、关系问题，自医享福，大大提高生命质量。练习中医瑜伽好处很多，具体说来可以具体分为：
						</div>
						<div className="teacher-info-content">
							1.清理身体垃圾，疏通筋络，解决肩背僵硬、手脚凉、头晕、心肺失调问题
						</div>
						<div className="teacher-info-content">
							2.调理脾胃，可有效解决容易发胖、三高、长结节的问题
						</div>
						<div className="teacher-info-content">
							3.打通下焦，解决脸色黄、睡眠差问题，延缓衰老
						</div>
						<div className="teacher-info-content">
							4.调顺气机，改善气色、改善肠胃功能、解决排便等诸多问题
						</div>
						<div className="teacher-info-content">
							5.掌握养精血经络医理，练习相对应的瑜伽体式，可更好地抗衰逆龄、美体回春
						</div>
						<div className="teacher-info-content">
							6.长期系统练习，可进一步缓解腰椎疼痛，启动自身大药房，提高免疫力开启防病系统
						</div>
						<div className="teacher-info-content">
							7.掌握独家疼痛理疗、中医流运动，达到快速止痛的作用
						</div>
						<div className="teacher-info-content">
							8.学习国学养生，顺道养生，身心同调，告别结节，凝神静气，达到疗愈身心，自医自愈
							......
						</div>
						<div className="teacher-info-title">四、中医瑜伽的缘起与流行</div>
						<div className="teacher-info-content">
							中医瑜伽的概念由陈浙南老师率先提出。2018年，中医瑜伽体系由陈浙南老师在一带一路国际瑜伽大会上正式提出。中医瑜伽体系从诞生到传播盛行，耗费了陈浙南老师数十年的心血，也经历了长时间的实践与检验。
						</div>
						<div className="teacher-info-content">
							首先，陈浙南老师是一个精通瑜伽并有数十年瑜伽教学经验的人，他从高中毕业后就酷爱瑜伽，遍寻瑜伽大师练习多年后，在2011年便开设了第一家瑜伽馆，学员众多，甚受欢迎，于是不断开设第2家、第3家......慢慢地，他发现来练瑜伽的人，除了强身健体，她们总会苦恼于有各种各样的身体病痛问题无法解决，于是陈浙南很想帮助他们并找寻解决之法。
						</div>
						<div className="teacher-info-content">
							在瑜伽的研习上，陈浙南老师孜孜不倦、不断进阶。2013年，他拜师韩国瑜伽第一人金利眩先生，勤学苦练瑜伽功法。
						</div>
						<div className="teacher-info-content">
							无论他把瑜伽研习到哪种境界，都无法解决很多瑜伽学员的身体疼痛疾病。陈浙南很想帮助她们！
							于是，百般求索，陈浙南老师在2014年，走进百草箱，师从中医大家赖世伦（师父系国学大师南怀瑾）学传统中医，深得中医医理之精妙。在百草箱的学习，让陈浙南建立了传承中医、真修育明人的初心——要把好的资产奉献给人类，奉献给社会，奉献给我们的国家。“为之于民，举而措之”，成为陈浙南印在心里的发心，成为他后来认定的一辈子生命价值的所在。
						</div>
						<div className="teacher-info-content">
							除了学习赖师的精髓，陈浙南也修习中医其他相关特长技术。2017年，他获得波士顿回归中医药大学三年制中医学结业证书；2019年，师从贵州名医、贵州中医药大学硕士生导师、中国名老中医黄琴老师学习经方；2023年，师从中央保健局原特聘正骨专家——吴石华教授学习北派按摩和正骨手法......
						</div>
						<div className="teacher-info-content">
							中医瑜伽体系是一套适合中国人体质的「养生防病体系」，
							陈浙南老师花了10年的时间潜心钻研。中医瑜伽结合了中医大家赖世伦老师平日教授的养生功法和心法，将印度瑜伽中的体式动作、根据中医十四正经循行分经归类。使学者通过手部触诊诊察经络变动和人迎寸口按脉比较人体阴阳气血偏差，最后运用瑜伽体位导引恢复人体气血平衡。
						</div>
						<div className="teacher-info-content">
							中医瑜伽主张“体位即是药”、“身体是个大药房”，陈浙南老师通过“特定设计的瑜伽体位法”进行导引，就可以将身体的气血精准引导到该淤堵部位，指哪打哪，就可以疏通经络，达到缓解病症、趋于健康的效果，解决了很多人的亚健康、慢性疾病，长期练习改善了体质养成健康体质。
						</div>
						<div className="teacher-info-content">
							2023年，陈浙南结缘兴趣岛，成为兴趣岛中医瑜伽首席讲师。他合作的兴趣学堂是国内生活和兴趣爱好学习平台，作为国内兴趣教育品牌，已有千位名师和千种兴趣课程，全面升级学员保障"六不公约"、师资标准、教学服务标准和课程打磨标准，为用户提供全领域兴趣成长课程，30大主流课程21门学员数量全国领先。
						</div>
						<div className="teacher-info-content">
							开启线上线下多面教学，陈浙南和他首创的中医瑜伽的影响力越来越大，至今已帮助100万+家庭重获健康。坚定初心的他始终在中医瑜伽的道路上孜孜前行、精进不怠，不断为中医瑜伽的发展贡献自己的力量，把中医瑜伽的好处惠及更多的人。
						</div>
					</div>
				)}
				{index === 3 && (
					<div className="teacher-info">
						<div className="teacher-info-title">个人简介</div>
						<div className="teacher-info-content">
							石今如（真名：石晓，网名：二妹姐），女，兴趣岛中医变美训练营首席讲师，中医美容专家兼高级艾灸师，作为养生导师参与过《美丽俏佳人》的拍摄，第一届中华芳香制作协会荣誉顾问，中医健康高级管理师，著有畅销书《香艾是最好的疗愈》，深入研究中医养生十几年，在养生保健方面具有深厚的理解和实践经验。现任北京二妹姐科技有限公司董事长，作为艾灸和芳香疗法结合之路上的探索者，她将艾灸与芳香疗法融合，独创了与众不同的香艾疗法，以平衡女性的身心健康。
						</div>
						<div className="teacher-info-title">人物经历</div>
						<div className="teacher-info-content">
							石今如坚持十多年中医保健与女性逆龄健康的研究、传承与实践。
						</div>
						<div className="teacher-info-content">
							1.2010年受邀参加阿曼与中国建交40周年活动。石今如深度研究芳疗护肤，作为乳香精油传播大使曾在阿曼受到阿曼小王子接待。她称，精油作为西方的中草药，芳香护肤和中医美容有异曲同工之妙，都是沿经络而行，帮助人体防病和美容。
						</div>
						<div className="teacher-info-content">
							2.2015年石今如开设一档名为《女人都爱养生》的节目，分享自己的养生知识和经验。该节目迅速获得了广大听众的喜爱和支持，不到两年时间就吸引了超过400万的粉丝。此外，石今如还涉足了艾灸和芳香疗法领域，致力于结合这两种传统治疗方法，提供有益于身心的健康解决方案。
						</div>
						<div className="teacher-info-content">
							3.2018年出版畅销书籍《香艾是最好的疗愈》，豆瓣评分高达9.2，深受无数读者喜爱。
						</div>
						<div className="teacher-info-content">
							4.2019年作为节目《美丽俏佳人》的特约养生导师,参加节目录制。
						</div>
						<div className="teacher-info-content">
							5.2019年,石今如前往日本台湾各地做逆龄抗衰产品的深度调研。
						</div>
						<div className="teacher-info-content">
							6.2019年,石今如的中医抗衰专辑《宫廷美颜术》登录北京地铁各大站线，为市民滚动传播中医抗衰理念。
						</div>
						<div className="teacher-info-content">
							7.2022年，石今如与一众知名健康专家受邀南方健康4周年系列活动——《健谈》直播研讨，与十几位健康传播大咖进行3小时全方位交流。
						</div>
						<div className="teacher-info-content">
							8.2024年1月，与兴趣岛中医变美训练营合作推出《28天面部轮廓抗衰营》，深受学员的好评。
						</div>
					</div>
				)}
				{index === 4 && (
					<div className="teacher-info">
						<div className="teacher-info-title">个人简介</div>
						<div className="teacher-info-content">周航，字航君，男，湖北武汉人。</div>
						<div className="teacher-info-content">
							道家养生修真文化教育者，辟谷及导引养生传播者，现任兴趣岛道家养生首席讲师。
						</div>
						<div className="teacher-info-content">
							全真龙门派第十五代丹道传人，武当和式太极第十三代传人，师承胡耀贞大师弟子。
						</div>
						<div className="teacher-info-content">
							资深健康管理师、国家二级心理咨询师。
						</div>
						<div className="teacher-info-title">人物经历</div>
						<div className="teacher-info-content">
							2005 年，周航正式投身健康教育领域。
						</div>
						<div className="teacher-info-content">
							2006年 创业建立至真养生本源文化传播工作室。
						</div>
						<div className="teacher-info-content">
							2007年 正式开启养生文化及技术的相关培训班。
						</div>
						<div className="teacher-info-content">
							2009年 华中科技大学文华学院特聘为公共课讲师。
						</div>
						<div className="teacher-info-content">
							2011年 养生课程教培体系全面完善。
						</div>
						<div className="teacher-info-content">
							集合道家吐纳、经络、太极、瑜伽等传统养生文化项目导入到健康管理概念中，以提升能量为核心功能的课程定位，倡导辅助养生新概念。于全国各地定期举办，培训学员涉及医疗、卫生、保健等多个行业领域。
						</div>
						<div className="teacher-info-content">
							2012年 成立企业健康管理咨询服务中心。
						</div>
						<div className="teacher-info-content">
							针对企事业单位员工提供特色健康评估、健康讲座、办公室亚健康自助康复服务、EAP（员工心理援助）计划等服务。
						</div>
						<div className="teacher-info-content">
							2013年 创建深蓝海生命研修会身心灵学习平台。
						</div>
						<div className="teacher-info-content">
							打造热爱探索生命科学的社会精英交流平台，整合并研发生命科学相关领域，包括养生学、哲学、心理学、道学、禅学，为社会大众及企事业单位组织各类禅修疗愈课程、心灵成长培训讲座及游学活动等。
						</div>
						<div className="teacher-info-content">
							2015年 受邀湖北电视台，生活频道记者专题采访道家辟谷养生。
						</div>
						<div className="teacher-info-content">
							2017年 武汉广播电台特邀嘉宾老师，访谈道家养生之辟谷术。
						</div>
						<div className="teacher-info-content">
							2018年
							受邀于湖北省非遗文化研究中心，成立传统道家养生研究小组，参与有关辟谷养生的学术科研及实验。
						</div>
						<div className="teacher-info-content">美国AAPMR2015康养年会受邀嘉宾。</div>
						<div className="teacher-info-content">
							中国康复学会专业委员会物理治疗学术论坛代表。
						</div>
						<div className="teacher-info-content">
							首届中国传统文化与与系统排列高峰论坛嘉宾。
						</div>
						<div className="teacher-info-content">
							受邀于《瑜伽》杂志约稿，发表道家养生文化专题论文。
						</div>
						<div className="teacher-info-content">
							首届国际青年瑜伽大会受邀嘉宾老师。
						</div>
						<div className="teacher-info-content">
							第二届西湖国际瑜伽论坛暨艺术节受邀嘉宾，道家养生专题报告。
						</div>
						<div className="teacher-info-content">
							首届亚洲瑜伽经管峰会受邀嘉宾老师。
						</div>

						<div className="teacher-info-content">历届中国瑜伽生活周特邀嘉宾老师。</div>
					</div>
				)}
			</div>
		</Modal>
	);
};
export default dialog;
